import { ActionBrick, registerBrick, ErrorFlow } from 'olympe';
import { fromJson } from './helpers';

export default class RGProcessChangesForJSONString extends ActionBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<!RGChange>} changes
     * @param {string} json
     * @param {function()} forwardEvent
     * @param {function(!ErrorFlow)} setErrorFlow
     * @param {function(string)} setNewJson
     */
    update(_$, [changes, json], [forwardEvent, setErrorFlow, setNewJson]) {
        const [data, error] = fromJson(json);
        if(!error) {
            const errors = ['No changes applied because:'];
            changes.forEach(change => {
                if(change.metadata.newCell.validator?.(change.newValue) ?? true) {
                    data[change.metadata.rowId][change.property] = change.newValue;
                }
                else {
                    errors.push(`This value is not valid: ${change.newValue}`);
                }
            });
            if(errors.length > 1) {
                setErrorFlow(ErrorFlow.create(errors.join('\n'), 1));
                return;
            }
            setNewJson(JSON.stringify(data));
            forwardEvent();
        }
        else {
            setErrorFlow(ErrorFlow.create(`input 'json' is not valid, error: ${error.message}`, 0));
        }
    }
}

registerBrick('01921e064dbe25faec55', RGProcessChangesForJSONString);
